<template>
	<div id="rootVM" v-cloak style="display: flex; flex-direction: row; flex-wrap: wrap">
		<div style="display: flex; flex-direction: row; width: 1098px">
			<div style="display: flex; flex-direction: column; width: 1098px">
				<!-- <div style="display: flex; flex-direction: row"> -->
				<div v-if="dangerOccurRealtime != null" class="boxBorder" style="width: 1080px; height: 430px; margin-right: 10px">
					<div style="100%">
						<div class="contentBox" style="height: 100%; display: flex">
							<div style="width: 720px; height: 428px">
								<div style="cursor: pointer; width: 100%; height: 100%; text-align: center; float: left; margin-right: 20px" @click="curEventFrames">
									<!-- <img :src="dangerOccurRealtimeImgSrc" style="width: auto; height: auto; max-width: 330px; max-height: 240px" /> -->
									<img :src="dangerOccurRealtimeImgSrc" style="width: 100%; height: 100%; object-fit: unset" />
								</div>
							</div>
							<div style="width: 360px">
								<div class="boxBorder">
									<div style="width: 100%; height: 48px; padding: 10px 0 0 10px; background: #fafafa; font-weight: bold">최근 위험 발생</div>
								</div>
								<div class="boxBorder">
									<div style="width: 350px; height: 238px; margin-left: 10px; overflow: hidden">
										<br />
										<span style="color: #008cd6; font-size: 23px">{{ dangerOccurRealtime.dangerOccurDtm }}</span>
										<br />
										<br />
										<div class="rt-dvsn">
											{{ dangerOccurRealtime.videoDangerActnDvsnNm }}
										</div>
										<div class="rt-row">
											<div class="rt-row-tt">
												<span>○ 현 장 명:</span>
											</div>
											<div class="rt-row-ct">
												<span>{{ dangerOccurRealtime.siteNm }}</span>
											</div>
										</div>
										<div class="rt-row">
											<div class="rt-row-tt">
												<span>○ C C T V:</span>
											</div>
											<div class="rt-row-ct">
												<span>[{{ dangerOccurRealtime.cctvNm }}]</span>
												<span>{{ dangerOccurRealtime.cctvInstallPlaceCont }}</span>
											</div>
										</div>
										<div class="rt-row">
											<div class="rt-row-tt">
												<span>○조치내용:</span>
											</div>
											<div class="rt-row-ct">
												<span>[{{ dangerOccurRealtime.objectNm }}]</span>
												<span>{{ dangerOccurRealtime.targetNm }}</span>
											</div>
										</div>
									</div>
									<!-- <div style="margin-left: -10px" process> -->
									<div process>
										<div
											class="boxBorder"
											id="bd"
											style="cursor: pointer; margin-top: 49px; padding: 0px; font-size: 15px; display: flex; width: 360px; height: 91px"
										>
											<div @click="clickedRedirectionDangerOccur">
												<div>
													<img src="/images/delay.png" />
													위험발생
												</div>
												<div>
													<span style="color: #ff0000">{{ currentWarnWorkDangerOccur.dangerOccurCnt }}</span>
													건
												</div>
											</div>
											<div @click="clickedRedirectionDangerOccurTakingAction">
												<div>
													<img src="/images/review.png" />
													조치 중
												</div>
												<div>
													<span style="color: #5bc0de">{{ currentWarnWorkDangerOccur.takingActionCnt }}</span>
													건
												</div>
											</div>
											<div @click="clickedCnt('actn')">
												<div>
													<img src="/images/end.png" />
													완료
												</div>
												<div>
													<span style="color: #00b050">{{ currentAccidentPreventItem.actnCnt }}</span>
													건
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div v-if="dangerOccurRealtime == null" class="boxBorder" style="width: 1080px; height: 430px; margin-right: 10px">
					<div class="titleBox">최근 위험 발생</div>
					<div style="display: flex; width: 100%; height: 380px; justify-content: center; padding-top: 35px">
						<div class="contentBox" style="height: 260px">
							<div style="display: flex">
								<div><img src="/images/icon-no-result.png" no-result /></div>
								<div style="padding-top: 90px">
									<span>{{ nonDangerOccurResultStr }}</span>
								</div>
							</div>
							<div process>
								<div class="boxBorder" id="bd" style="cursor: pointer; margin-top: 10px; padding: 0px; font-size: 15px; display: flex; height: 91px">
									<div @click="clickedRedirectionDangerOccur">
										<div>
											<img src="/images/delay.png" />
											위험발생
										</div>
										<div>
											<span style="color: #ff0000">{{ currentWarnWorkDangerOccur.dangerOccurCnt }}</span>
											건
										</div>
									</div>
									<div @click="clickedRedirectionDangerOccurTakingAction">
										<div>
											<img src="/images/review.png" />
											조치 중
										</div>
										<div>
											<span style="color: #5bc0de">{{ currentWarnWorkDangerOccur.takingActionCnt }}</span>
											건
										</div>
									</div>
									<div @click="clickedCnt('actn')">
										<div>
											<img src="/images/end.png" />
											완료
										</div>
										<div>
											<span style="color: #00b050">{{ currentAccidentPreventItem.actnCnt }}</span>
											건
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div notice>
					<div class="boxBorder" style="height: 50px; margin-bottom: 10px; margin-right: 10px">
						<div class="nt-guide" style="display: flex; justify-content: center; align-items: center">
							<span style="display: inline-block">최신 공지사항</span>
						</div>
						<div style="width: 80%">
							<div v-for="(notice, index) in noticeInfo" :key="index" @click="showNoticeDetail(index)" style="width: 100%">
								<span style="display: inline-block; width: 50%; text-decoration: underline">{{ notice.noticeTitle }}</span>
								<span style="display: inline-block; width: 25%; text-align: right" v-if="notice.oriFileNm != ''">
									<i class="icon-attachment"></i>
								</span>
								<span style="display: inline-block; width: 25%; text-align: right" v-if="notice.oriFileNm == ''"></span>
								<span style="display: inline-block; width: 12%; text-align: center">{{ notice.regUser }}</span>
								<span style="display: inline-block; width: 12%; text-align: center">{{ notice.regDtm }}</span>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="RFlex" style="display: flex; flex-direction: column">
				<div class="boxBorder" style="width: 350px; height: 73px; margin-bottom: 10px; margin-right: 10px">
					<div id="ClockAndDate">
						<clock-and-date :loginUserSiteNm="loginUserSiteNm"></clock-and-date>
					</div>
				</div>
				<div class="boxBorder" style="width: 100%; height: 407px">
					<div class="titleBox">
						발생 위험유형
						<span style="font-size: 13px">{{ objectTargetDangerOccurPeriod.start }} ~ {{ objectTargetDangerOccurPeriod.end }}</span>
					</div>
					<div class="contentBox object-danger-content" style="padding: 8px">
						<div v-for="(item, index) in objectTargetDangerOccur.objectTargetDangerOccur" :key="index" class="object-danger">
							<div :class="item.classList" class="object-danger-row">
								<div class="name">{{ item.objectNm }}</div>
								<div class="name">{{ item.targetNm }}</div>
								<div class="value">
									<span v-if="item.percent != undefined" class="percent">{{ item.percent }} /&nbsp;</span>
									<span>{{ item.objectTargetDangerCnt }}</span>
								</div>
							</div>
							<table bar>
								<tr>
									<td :style="item.tdWidth" :class="item.classList"></td>
									<td></td>
								</tr>
							</table>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div style="display: flex; flex-direction: row; width: 100%">
			<div
				class="boxBorder"
				style="display: flex; flex-direction: column; padding-top: 0px; padding-bottom: 0px; width: 50%; height: 300px; margin-right: 10px"
			>
				<div class="titleBox" style="display: flex; align-items: center; padding-left: 0; padding-top: 0">
					<div style="font-weight: bold; height: 48px; padding: 10px">현황</div>
					<div class="btn-group" style="margin-left: auto; padding: 0 10px">
						<button type="button" class="btn" style="width: 50px; height: 28px; padding: 0px" v-bind:class="chartClickClass[0]" @click="loadDayChart">
							일
						</button>
						<button
							type="button"
							class="btn"
							style="width: 50px; height: 28px; padding: 0px"
							v-bind:class="chartClickClass[1]"
							@click="loadWeekChart"
						>
							주
						</button>
						<button
							type="button"
							class="btn"
							style="width: 50px; height: 28px; padding: 0px"
							v-bind:class="chartClickClass[2]"
							@click="loadMonthChart"
						>
							월
						</button>
					</div>
				</div>
				<div style="flex: 5; margin: 3px auto 0 auto; width: 100%; padding: 0">
					<div id="lineChart" style="height: 100%"></div>
				</div>
			</div>
			<div class="boxBorder" style="width: 50%; height: 300px">
				<div class="titleBox">위험 보고</div>
				<div class="contentBox" style="height: 340px">
					<table>
						<tr>
							<th style="width: 25%">{{ dangerOccurTable.siteCctvNm }}</th>
							<th style="width: 20%">{{ dangerOccurTable.dangerOccurDtm }}</th>
							<th style="width: 17%">{{ dangerOccurTable.objectNm }}</th>
							<th style="width: 17%">{{ dangerOccurTable.targetNm }}</th>
							<th style="width: 16%">{{ dangerOccurTable.videoDangerActnDvsnNm }}</th>
						</tr>
						<tr v-for="(item, index) in dangerOccurReport" :key="index" @click="showDangerReportDetail(item)" style="cursor: pointer">
							<td>
								<span>[{{ item.siteNm }}]&ensp;</span>
								<span>{{ item.cctvNm }}</span>
							</td>
							<td>{{ item.dangerOccurDtm }}</td>
							<td>{{ item.objectNm }}</td>
							<td>{{ item.targetNm }}</td>
							<td>{{ item.videoDangerActnDvsnNm }}</td>
						</tr>
					</table>
				</div>
			</div>
		</div>
		<!-- 위험보고 그리드 클릭시의 모달/ TODO: 모달창 컴포넌트화-->
		<div ref="popupImg" class="modal">
			<!-- Modal content -->
			<div class="modal-content">
				<span @click="popupImgClose" class="close">&times;</span>
				<div style="height: 30px"></div>
				<div class="row" style="display: flex; align-items: center; justify-content: center">
					<div class="col-md-3">
						<div
							style="
								flex: 1;
								overflow-y: auto;
								flex-direction: column;
								height: 720px;
								max-height: 720px;
								border-right: 1px solid #ddd;
								padding-right: 15px;
							"
							left
						>
							<div
								style="position: relative; overflow: hidden"
								v-for="(item, index) in dangerOccurDetailsItem.inqDangerOccurFrameImgOutVOs"
								:key="index"
								:class="{ active: index == activePicture }"
								@click="selectPicture(index)"
								:tabindex="index"
								@keydown.up="priviousImage()"
								@keydown.left="priviousImage()"
								@keydown.down="nextImage()"
								@keydown.right="nextImage()"
								photo
							>
								<img :src="dangerOccurDetailsItem.inqDangerOccurFrameImgOutVOs[index].imgData" />

								<div>
									<div style="position: absolute; width: 100%; height: 100%; top: 50%; left: 50%; transform: translate(-50%, -50%)"></div>
								</div>
							</div>
						</div>
					</div>
					<div align="center" class="col-md-9">
						<div align="center" right style="flex: 5 1 0%; height: inherit; justify-content: center">
							<img id="popupImg" :src="this.popupImg.imgData" style="width: 910px; max-height: 520px; object-fit: contain; display: block" />
						</div>
						<div align="center" right style="flex: 5 1 0%; margin-left: 15px; justify-content: center">
							<div class="row">
								<div class="mBox col-md-3">
									<div><h4>장소 및 시각</h4></div>
									<div class="border-bottom"></div>
									<div style="margin-top: 10px; margin-left: 20px; font-size: 14px">
										{{ dangerOccurDetailsItem.cctvNm }} - {{ dangerOccurDetailsItem.cctvInstallPlaceCont }}
									</div>
									<div style="margin-top: 10px; margin-left: 20px; font-size: 14px">{{ popupImg.imgSaveDtm }}</div>
								</div>
								<div class="mBox">
									<div><h4>조치 대상</h4></div>
									<div class="border-bottom"></div>
									<div style="display: flex; justify-content: center" :key="forRerendering">
										<div
											class="objects"
											v-for="(element, index) in popupImg.objects"
											:key="index"
											style="display: inline-block; max-width: 50%; margin: 10px"
										>
											<div style="font-size: 14px; text-align: center" v-for="(objectAndTarget, i) in element" :key="i">
												{{ objectAndTarget }}
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import ClockAndDate from '@/components/ClockAndDate';
import apiIndex from '../../api/index';
import moment from 'moment';
const dangerOccurUrl = apiIndex.dangerOccur;
const mainUrl = apiIndex.main;
const accidentPreUrl = apiIndex.accidentPrevent;

let axiosExtention;
dangerOccurUrl;

export default {
	components: {
		ClockAndDate,
	},
	computed: {
		// API 호출 통계
		charData() {
			return {
				// 차트 x 축 데이터
				dataSource: [],
				// X축
				categoryAxis: {
					// 데이터를 가져올 필드명 세팅
					field: 'dateData',
					// rotation: 화면이 작아졌을 때 세로로 보여줄 거냐..
					// foramt: 값을 보여줄 형태 지정
					// step: 값이 몇 씩 증가하는가..
					labels: { rotation: 'auto', format: 'M/d', step: 1, font: '10px Arial, Helvetica, sans-serif' },
				},
				// Y축
				valueAxis: [
					// format: y축 데이터를 어떻게 표시할 것인가..
					{ labels: { format: '{0:n0}건', font: '11px Arial, Helvetica, sans-serif' } },
				],
				// 툴팁( 마우스 올렸을 때 나오는 조그만 정보 창 )
				tooltip: {
					// 툴팁 표시, 비표시 설정
					visible: true,
					// 툴팁 내용을 어떻게 표시할 것인가..
					template: `#: category #<br/>#: series.name # : #: kendo.toString(value, 'n0') #건`,
				},
				// 차트 원본 데이터(json 배열) 세팅
				series: [],
			};
		},
	},
	created() {
		axiosExtention = this.$jarvisExtention.axiosExtention;
		this.menuGubun = process.env.VUE_APP_MENU_GUBUN;
		this.objectTargetDangerOccurPeriod.start = moment().add(-6, 'day').format('YYYY-MM-DD');
		this.objectTargetDangerOccurPeriod.end = moment().format('YYYY-MM-DD');
	},
	async mounted() {
		// 메인 대시보드에서 content 관련 css에 의해 공백 생기는것 제거
		let contentRoot = document.getElementsByClassName('content');
		if (contentRoot.length > 0) {
			contentRoot[0].classList.remove('content');
		}
		this.popupImgClose();

		await this.getMainInfo();
		// 최신 공지사항 불러오기
		this.loadRecentlyNotice();

		// 위험 보고 항목 가져오기
		this.loadDangerOccurReport(); // 딜레이 없이 바로 표시하기 위함
		setInterval(() => {
			this.loadDangerOccurReport();
		}, 60000); // 1분 마다 갱신

		this.$axios // 조치대기, 검토대기, 완료, 금일마감, 마감지연
			.post(mainUrl.inqCurrentAccidentPrevent, {})
			.then(r => {
				this.currentAccidentPreventItem = JSON.parse(JSON.stringify(r.data));
			})
			.catch(axiosExtention.buildErrorHandler());

		this.loadDayChart();
	},
	data: () => ({
		pageParam: {},
		loginUserCompanyNm: '',
		loginUserSiteNm: '',
		loginUserNm: '',
		// 최근 재해조치 요청 목록
		latestInfoItem: {
			0: { accdtPrvtnPgssCdNm: '', path: '/images/noimage.png', reqDtm: '' },
			1: { accdtPrvtnPgssCdNm: '', path: '/images/noimage.png', reqDtm: '' },
			2: { accdtPrvtnPgssCdNm: '', path: '/images/noimage.png', reqDtm: '' },
		},
		// 현재 선택된 재해조치 요청
		currentInfoItem: {
			objectId: '',
			targetId: '',
			reqUserId: '',
			actnUserId: '',
			actnDtm: '',
			path: '/images/noimage.png',
		},
		warnWorkOccurs: '',
		currentWarnWorkDangerOccur: {
			dangerOccurCnt: '0',
			takingActionCnt: '0',
		},
		currentAccidentPreventItem: {
			reqCnt: '0',
			reviewCnt: '0',
			todayDelayCnt: '0',
			actnCnt: '0',
			accumulatedCnt: '0',
			delayCnt: '0',
		},
		accidentPreventItem: {},
		chartJson: [],
		todayDate: '', // 현재 날짜
		chartClickClass: ['btn-primary', 'btn-default', 'btn-default'],
		// 대상물 위험유형
		objectTargetDangerOccur: {},
		objectTargetDangerOccurPeriod: { start: '', end: '' },
		// 금일 주의작업
		todayNoneWarnWorkOccur: '금일 발생한 주의작업이 없습니다',
		todayWarnWorkOccurTotal: 0,
		todayWarnWorkOccur: [],
		// 위험 보고 테이블 정보
		dangerOccurTable: {
			siteCctvNm: 'CCTV 구역',
			dangerOccurDtm: '발생시간',
			objectNm: '대상물',
			targetNm: '조치사항',
			videoDangerActnDvsnNm: '상태',
		},
		// 위험 보고 리스트
		dangerOccurReport: [],
		// 실시간 이벤트
		dangerOccurRealtime: {},
		dangerOccurRealtimeImgSrc: '',
		nonDangerOccurResultStr: '현재 위험 발생한 이벤트가 없습니다',
		// 최신 공지사항
		noticeInfo: {},
		dangerOccurDetailsItem: {},
		popupImg: {},
		activePicture: 0,
		isImagePoppedUp: true,
		// dangerOccurObjectsAndTargets: {},
		// dangerOccurObjectsAtSequenceMap: {},
		dangerZoneAtSequenceMap: {},
		sequenceMapForDetail: {},
		outFramesDetailData: {},
		menuGubun: '',
		forRerendering: 0,
		chartObjectTargetList: [],
	}),
	watch: {
		// 팝업 모달이 생겨났을 때, 해당 이미지에 포커스를 두도록(키보드로 이미지를 바로 이동시킬 수 있게 하기 위함)
		isImagePoppedUp() {
			if (this.isImagePoppedUp == true) {
				this.$nextTick(function () {
					let selectedImage = document.getElementsByClassName('active')[0];
					selectedImage.focus();
				});
			}
		},
		// 활성화된 이미지가 변경됐을 때 이미지 데이터를 변경하기 위함
		activePicture() {
			this.popupImg = this.dangerOccurDetailsItem.inqDangerOccurFrameImgOutVOs[this.activePicture];
		},
	},
	methods: {
		curEventFrames() {
			let dangerOccurIndex = this.dangerOccurReport.findIndex(e => e.videoDangerActnDvsnNm == '위험 작업 발생');
			// this.showDangerReportDetail(this.dangerOccurReport[dangerOccurIndex], dangerOccurIndex);
			this.showDangerReportDetail(this.dangerOccurReport[dangerOccurIndex]);
		},
		async getMainInfo() {
			await this.$axios
				.post(mainUrl.mainInfo, {})
				.then(response => {
					if (response.data) {
						if (response.data.userInfo) {
							let userInfo = response.data.userInfo;
							this.loginUserCompanyNm = userInfo.companyNm;
							this.loginUserSiteNm = userInfo.siteNm;
							this.loginUserNm = userInfo.userNm;
						}

						if (response.data.warnWorkDangerOccur) {
							this.currentWarnWorkDangerOccur = response.data.warnWorkDangerOccur;
						}

						if (response.data.objectTargetDangerOccur) {
							this.objectTargetDangerOccur = response.data.objectTargetDangerOccur;
							let total = this.objectTargetDangerOccur.objectTargetDangerOccurTotal;
							let list = this.objectTargetDangerOccur.objectTargetDangerOccur;
							if (total != 0) {
								let value = 100 / total;
								// 항목별 퍼센트 세팅(소수점 두자리)
								for (let i = 0; i < list.length; i++) {
									let percent = Math.round(list[i].objectTargetDangerCnt * value * 100) / 100;
									list[i].percent = percent + '%';
									list[i].tdWidth = 'width: ' + percent + '%';
									if (percent > 30) list[i].classList = 'red';
									else if (percent > 0) list[i].classList = 'blue';
									else list[i].classList = '';
								}
							}
						}

						if (response.data.todayWarnWorkOccur) {
							let data = response.data.todayWarnWorkOccur;

							let todayWarnWorkOccur = [];
							for (let i = 0; i < data.length; i++) {
								if (data[i].objectId == 'total') this.todayWarnWorkOccurTotal = data[i].warnWorkOccurCnt;
								else todayWarnWorkOccur.push(data[i]);
							}
							this.todayWarnWorkOccur = todayWarnWorkOccur;
						}

						this.chartObjectTargetList = response.data.chartObjectTargetList;
					}
				})
				.catch(axiosExtention.buildErrorHandler());
		},
		changeChartClickClass(index) {
			let changeList = [];
			this.chartClickClass.forEach((e, idx) => {
				if (idx === index) {
					changeList.push('btn-primary');
				} else {
					changeList.push('btn-default');
				}
			});
			this.chartClickClass = changeList;
		},
		// 차트 그리기
		drawChart() {
			$('#lineChart').kendoChart({
				dataSource: this.charData.dataSource,
				categoryAxis: this.charData.categoryAxis,
				valueAxis: this.charData.valueAxis,
				series: this.charData.series,
				legend: {
					position: 'bottom',
				},
				tooltip: this.charData.tooltip,
			});
		},
		// 월/주/일 데이터 로드 후 차트에서 보여주기 위해 데이터 세팅
		createChartData(data) {
			// 대상물-조치대상 개수
			let listSize = this.chartObjectTargetList.length;
			// 대상물-조치대상 개수 리스트
			let dangerOccurCntList = [];
			for (let i = 0; i < listSize; i++) {
				let list = [];
				dangerOccurCntList.push(list);
			}

			// 데이터 비우고 다시 세팅
			this.charData.dataSource = [];
			data.forEach(d => {
				// 날짜
				this.charData.dataSource.push({ dateData: d.dateData });
				// 대상물-조치대상 개수를 각 번호에 쭉 push
				for (let i = 0; i < listSize; i++) {
					dangerOccurCntList[i].push(d.objectTargetDangerCnts[i]);
				}
			});

			let series = [];
			// 색 설정 안하면 자동으로 설정됨
			let color = ['#034EA2', '#5BC0DE', '#00B050', '#FF0000'];

			// 그래프 세팅
			for (let i = 0; i < listSize; i++) {
				let line = {
					type: 'line',
					data: dangerOccurCntList[i],
					name: this.chartObjectTargetList[i].objectNm + '\n' + this.chartObjectTargetList[i].targetNm,
					color: color[i],
				};
				series.push(line);
			}

			// 데이터 비우고 다시 세팅
			this.charData.series = [];

			for (let i = 0; i < listSize; i++) {
				this.charData.series.push(series[i]);
			}

			this.drawChart();
		},
		// 일 그래프
		loadDayChart() {
			this.$axios
				.post(mainUrl.inqDayChartForIron, {})
				.then(response => {
					this.changeChartClickClass(0);
					this.chartJson = response.data;
					this.createChartData(response.data);
				})
				.catch(axiosExtention.buildErrorHandler());
		},
		// 주 그래프
		loadWeekChart() {
			this.$axios
				.post(mainUrl.inqWeekChartForIron, {})
				.then(response => {
					this.changeChartClickClass(1);
					this.chartJson = response.data;
					this.createChartData(response.data);
				})
				.catch(axiosExtention.buildErrorHandler());
		},
		// 월 그래프
		loadMonthChart() {
			this.$axios
				.post(mainUrl.inqMonthChartForIron, {})
				.then(response => {
					this.changeChartClickClass(2);
					this.chartJson = response.data;
					this.createChartData(response.data);
				})
				.catch(axiosExtention.buildErrorHandler());
		},
		// 재해조치 요청 목록 클릭
		latestDetail(index) {
			// 현재 선택된 값을 바꿔줌
			this.currentInfoItem = this.latestInfoItem[index];
		},
		clickedCnt(kind) {
			let param = { kind: kind };
			// 권한 체크
			const accidentPre = $('a[data-desc="재해예방조치"]');
			if (accidentPre && accidentPre.length > 0) {
				// 기존 pageParam 내용 불러오기
				this.$axios
					.post(accidentPreUrl.viewAccidentPrevent, new URLSearchParams(param))
					.then(
						function (r) {
							if (r.data.token) delete r.data.token;
							sessionStorage.setItem('accidentPreventPageParam', JSON.stringify(r.data));
							location.href = '/accident-prevent';
						}.bind(this),
					)
					.catch(axiosExtention.buildErrorHandler());
			}
		},
		clickedRedirectionDashboard() {
			window.open('/dashboard');
		},
		// 위험발생 n건 클릭 시 화면 이동
		clickedRedirectionDangerOccur() {
			const dangerOccur = $('a[data-desc="위험발생이력"]');

			if (dangerOccur && dangerOccur.length > 0) {
				dangerOccur[0].click();
			}
		},
		// 조치중 클릭 시 화면 이동
		clickedRedirectionDangerOccurTakingAction() {
			const dangerOccur = $('a[data-desc="위험발생이력"]');
			if (dangerOccur && dangerOccur.length > 0) {
				this.$axios
					.post(dangerOccurUrl.viewDangerOccur, new URLSearchParams({ videoDangerActnDvsnCd: '03' }))
					.then(
						function (r) {
							if (r.data.token) delete r.data.token;
							sessionStorage.setItem('dangerOccurPageParam', JSON.stringify(r.data));
							location.href = r.data.viewUrl;
						}.bind(this),
					)
					.catch(axiosExtention.buildErrorHandler());
			}
		},
		loadDangerOccurReport() {
			this.$axios
				.post(mainUrl.inqDangerOccurReport, { ironMain: 'true' })
				.then(r => {
					let data = r.data;

					const commonCodeList = JSON.parse(sessionStorage.getItem('commonCodeList'));
					let videoDangerActnDvsnCdOption = commonCodeList.filter(item => item.grpCd == 'video_danger_actn_dvsn_cd');

					// 위험 보고 리스트
					let dangerOccurReportList = data.dangerOccurReportList;
					if (dangerOccurReportList && dangerOccurReportList.length > 0) {
						for (let i = 0; i < dangerOccurReportList.length; i++) {
							dangerOccurReportList[i].videoDangerActnDvsnNm = videoDangerActnDvsnCdOption.filter(
								item => item.value == dangerOccurReportList[i].videoDangerActnDvsnCd,
							)[0].text;
						}

						this.dangerOccurReport = dangerOccurReportList;
					}

					// 실시간 이벤트
					this.dangerOccurRealtime = data.dangerOccurRealtime;

					if (this.dangerOccurRealtime != null) {
						this.dangerOccurRealtime.videoDangerActnDvsnNm = videoDangerActnDvsnCdOption.filter(
							item => item.value == this.dangerOccurRealtime.videoDangerActnDvsnCd,
						)[0].text;

						this.getRealtimeEventImg(this.dangerOccurRealtime);
					}
				})
				.catch(axiosExtention.buildErrorHandler());
		},
		getRealtimeEventImg(item) {
			this.$axios
				.post(mainUrl.imgRealtimeEvent, item)
				.then(r => {
					this.dangerOccurRealtimeImgSrc = 'data:image/jpg;base64,' + r.data.imgVO.imgByte;
				})
				.catch(axiosExtention.buildErrorHandler());
		},
		loadRecentlyNotice() {
			this.$axios
				.post(mainUrl.inqRecentlyNotice, {})
				.then(r => {
					this.noticeInfo = r.data;
				})
				.catch(axiosExtention.buildErrorHandler());
		},
		showNoticeDetail(index) {
			if (!this.noticeInfo[index] || !this.noticeInfo[index].noticeId) {
				return alert('공지사항 정보가 올바르지 않습니다');
			}
			// 팝업창 가로/세로크기
			let w = 600;
			let h = 600;

			let url = 'recently-notice?notice_id=' + this.noticeInfo[index].noticeId;
			let title = 'recently-notice-popup';

			var left = screen.width / 2 - w / 2;
			var top = screen.height / 2 - h / 2;
			return window.open(
				url,
				title,
				'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=' +
					w +
					', height=' +
					h +
					', top=' +
					top +
					', left=' +
					left,
			);
		},
		showDangerReportDetail(item) {
			this.dangerOccurDetailsItem = {};
			this.dangerOccurObjectsAtSequenceMap = {};
			this.popupImg = {};
			this.$axios
				.post(dangerOccurUrl.inqOneDangerOccur, {
					siteId: item.siteId,
					cctvId: item.cctvId,
					objectId: item.objectId,
					targetId: item.targetId,
					dangerOccurObjectSeq: item.dangerOccurObjectSeq,
					strtFrameImgSeq: item.strtFrameImgSeq,
					endFrameImgSeq: item.endFrameImgSeq,
					dangerOccurDtm: item.dangerOccurDtm,
				})
				.then(
					function (response) {
						//그리드에서 row를 선택했을 때 detailsItem 세팅용
						this.setDetailsItem(response.data, item);
						//이미지 데이터 세팅
						this.setAllFramesToImageData();
						//  맵에 시퀀스를 키로, 대상물과 조치사항/위험지역명을 세팅
						// this.setSequenceMap();
						// // 시퀀스맵을 활용해서 대상물과 조치사항이 있는 시퀀스에 대상물과 조치사항을 세팅
						// this.setObjectsAndTargetsToDetailsItem();
						// img 클릭 시 popup
						this.$nextTick(function () {
							this.popupImg = this.dangerOccurDetailsItem.inqDangerOccurFrameImgOutVOs[this.activePicture];
							// this.activePicture = this.dangerOccurDetailsItem.inqDangerOccurFrameImgOutVOs.findIndex(e => e.imgSaveDtm == item.dangerOccurDtm);
							this.$refs.popupImg.style.display = 'block';
							this.isImagePoppedUp = true;
							this.selectPicture(this.activePicture);
						});
					}.bind(this),
				)
				.catch(axiosExtention.buildErrorHandler());
		},
		//모달창에서 키 다운으로 이전 이미지로 이동
		priviousImage() {
			if (this.activePicture > 0) {
				this.activePicture = this.activePicture - 1;
				this.selectPicture(this.activePicture);
			}
		},
		//모달창에서 키 다운으로 다음 이미지로 이동
		nextImage() {
			if (this.activePicture < this.dangerOccurDetailsItem.inqDangerOccurFrameImgOutVOs.length - 1) {
				this.activePicture = this.activePicture + 1;
				this.selectPicture(this.activePicture);
			}
		},
		//모달창에서 이미지를 선택했을 때
		selectPicture(index) {
			if (index < 0 || index >= this.dangerOccurDetailsItem.inqDangerOccurFrameImgOutVOs.length) {
				return;
			}
			this.activePicture = index;
			let lastIndexOfFrame = this.dangerOccurDetailsItem.inqDangerOccurFrameImgOutVOs.length - 1;
			let endFrameImgSeq = this.dangerOccurDetailsItem.inqDangerOccurFrameImgOutVOs[lastIndexOfFrame].frameImgSeq;
			this.$axios
				.post(dangerOccurUrl.inqImgDetailsInfo, {
					siteId: this.dangerOccurDetailsItem.siteId,
					cctvId: this.dangerOccurDetailsItem.cctvId,
					frameImgSeq: this.dangerOccurDetailsItem.inqDangerOccurFrameImgOutVOs[this.activePicture].frameImgSeq,
					endFrameImgSeq: endFrameImgSeq,
				})
				.then(
					function (r) {
						let objects = [];
						if (r.data != '') {
							r.data.forEach(e => {
								let objectAndTarget = [];
								objectAndTarget.push(e.objectNm);
								objectAndTarget.push(e.targetNm);
								objects.push(objectAndTarget);
							});
						}
						this.popupImg.objects = objects;
						this.forRerendering += 1;
					}.bind(this),
				)
				.catch(axiosExtention.buildErrorHandler());
			//스크롤바를 내리는 용도
			let distance = (index - 10) * 10;
			$('.modal-content [left]').animate({ scrollTop: index * 130 - 170 + distance }, 50);
		},
		popupImgClose() {
			// img popup 닫기
			this.$refs.popupImg.style.display = 'none';
			this.isImagePoppedUp = false;
			this.activePicture = 0;
		},
		setDetailsItem(data, selectedRowItem) {
			this.dangerOccurDetailsItem = $.extend(true, {}, data);
			this.dangerOccurDetailsItem.dangerOccurDtm = selectedRowItem.dangerOccurDtm;
			this.dangerOccurDetailsItem.objectId = selectedRowItem.objectId;
			this.dangerOccurDetailsItem.targetId = selectedRowItem.targetId;
			this.dangerOccurDetailsItem.dangerOccurObjectSeq = selectedRowItem.dangerOccurObjectSeq;
			this.dangerOccurDetailsItem.videoDangerActnDvsnCd = selectedRowItem.videoDangerActnDvsnCd;
			this.dangerOccurDetailsItem.actnReasonCont = selectedRowItem.actnReasonCont;
			this.dangerOccurDetailsItem.strtFrameImgSeq = selectedRowItem.strtFrameImgSeq;
			this.dangerOccurDetailsItem.obejctNm = selectedRowItem.obejctNm;
			this.dangerOccurDetailsItem.targetNm = selectedRowItem.targetNm;
			this.dangerOccurDetailsItem.cctvNm = selectedRowItem.cctvNm;
			this.dangerOccurDetailsItem.cctvInstallPlaceCont = selectedRowItem.cctvInstallPlaceCont;
		},
		//이미지 데이터 세팅
		setAllFramesToImageData() {
			this.dangerOccurDetailsItem.inqDangerOccurFrameImgOutVOs.forEach(e => {
				this.$axios.post(dangerOccurUrl.imgOneDangerOccur, { fileName: e.imgSaveFileNm }).then(response => {
					e.imgData = 'data:image/jpg;base64,' + response.data.imgByte;
				});
			});
		},
		//타겟을 중복없이 세팅
		setTargetNmsToObjectWithoutDuplication(vo, targetMap) {
			let filter = targetMap[vo.objectNm].filter(e => e == vo.targetNm);
			if (vo.targetNm != null && filter != undefined && filter.length == 0) {
				targetMap[vo.objectNm].push(vo.targetNm);
			}
		},
		// 맵에 시퀀스를 키로, 대상물과 조치사항/ 위험지역을 세팅
		setSequenceMap() {
			this.dangerOccurDetailsItem.inqDangerOccurFrameImgOutVOs.forEach(imgInfo => {
				//각 프레임의 이미지 정보로 outFramesDetailData에 값을 세팅. 대상물 및 위험지역이 있는 시퀀스만 추려내는 작업
				//Refactor: 굳이 이 과정이 없어도 될 것 같다.
				this.makeOutFramesDetailData(imgInfo);
				//위험지역명을 저장할 배열
				var dangerZoneNms = [];
				if (this.outFramesDetailData != undefined && this.outFramesDetailData[imgInfo.frameImgSeq] != undefined) {
					this.outFramesDetailData[imgInfo.frameImgSeq].forEach(element => {
						//각 시퀀스에 해당하는 대상물(+조치대상)들을 sequenceMap에 세팅
						this.setObjectNmsToSequenceMapForDetail(imgInfo, element);
						//해당 시퀀스에 위험지역명이 있으면
						if (element.dangerZoneNm != null) {
							//위험지역명저장
							dangerZoneNms.push(element.dangerZoneNm);
						}
					});
					//sequenceMapForDetail의 해당 시퀀스에 위험지역명 추가
					this.$set(this.sequenceMapForDetail[imgInfo.frameImgSeq], 'dangerZoneNms', Array.from(new Set(dangerZoneNms)));
				}
			});
		},
		//sequenceMapForDetail의 해당 시퀀스에 맞는 objectNms를 세팅하는 작업
		//Refactor: Set을 활용하면 좀 더 단순하게 할 수 있는 방법이 있지 않을까?
		setObjectNmsToSequenceMapForDetail(imgInfo, outFramesDetailDataElement) {
			if (this.sequenceMapForDetail[imgInfo.frameImgSeq] == undefined) {
				this.$set(this.sequenceMapForDetail, imgInfo.frameImgSeq, {});
			}
			if (this.sequenceMapForDetail[imgInfo.frameImgSeq].objectNms == undefined) {
				this.$set(this.sequenceMapForDetail[imgInfo.frameImgSeq], 'objectNms', new Object());
			}
			if (this.sequenceMapForDetail[imgInfo.frameImgSeq]['objectNms'][outFramesDetailDataElement.objectNm] == undefined) {
				this.$set(
					this.sequenceMapForDetail[imgInfo.frameImgSeq]['objectNms'],
					outFramesDetailDataElement.objectNm,
					new Array(outFramesDetailDataElement.targetNm),
				);
			} else {
				this.setObjectInfosWithoutDuplication(outFramesDetailDataElement, this.sequenceMapForDetail[imgInfo.frameImgSeq]['objectNms']);
			}
		},
		// //타겟을 중복없이 세팅
		setObjectInfosWithoutDuplication(vo, targetMap) {
			if (targetMap[vo.objectNm] == undefined || targetMap[vo.objectNm][0] == null) {
				return;
			}
			let filter = targetMap[vo.objectNm].filter(e => e == vo['targetNm']);
			if (vo['targetNm'] != null && filter != undefined && filter.length == 0) {
				targetMap[vo.objectNm].push(vo['targetNm']);
			}
		},
		setObjectsAndTargetsToDetailsItem() {
			this.dangerOccurDetailsItem.inqDangerOccurFrameImgOutVOs.forEach(e => {
				if (this.sequenceMapForDetail[e.frameImgSeq] != undefined) {
					if (this.sequenceMapForDetail[e.frameImgSeq].objectNms != undefined) {
						this.$set(e, 'objects', this.sequenceMapForDetail[e.frameImgSeq].objectNms);
					}
					if (this.sequenceMapForDetail[e.frameImgSeq].dangerZoneNms.length != 0) {
						this.$set(e, 'dangerZoneNms', this.sequenceMapForDetail[e.frameImgSeq].dangerZoneNms);
					}
				}
			});
		},
		//각 프레임의 이미지 정보로 outFramesDetailData에 값을 세팅. 대상물 및 위험지역이 있는 시퀀스만 추려내는 작업
		makeOutFramesDetailData(imgInfo) {
			let frameImgSeqData = this.dangerOccurDetailsItem.inqDangerOccurFrameImgDetailOutVOs.filter(e => e.frameImgSeq == imgInfo.frameImgSeq);
			if (frameImgSeqData.length != 0) {
				this.$set(this.outFramesDetailData, imgInfo.frameImgSeq, frameImgSeqData);
			}
		},
	},
};
</script>

<style scoped>
/* 새로 */
body .content-wrapper {
	height: 100% !important;
}
body .content {
	padding: 0 !important;
}
#bd > div {
	/* height: 109px;
	padding-top: 12px; */
	height: 80px;
	padding-top: 5px;
}
#rootVM {
	width: 1440px;
	height: 100%;
	/* overflow-y: auto; */
	-ms-overflow-style: none;
	scrollbar-width: none;

	font-family: -apple-system, BlinkMacSystemFont, 'Malgun Gothic', '맑은 고딕';
	margin: 24px auto;
	margin-bottom: 0;
}
#rootVM::-webkit-scrollbar {
	display: none;
}
#rootVM > div {
	font-size: 1.4em;
	width: 100%;
	display: flex;
}
.boxBorder {
	border: 1px solid #ddd;
	border-radius: 3px;

	box-shadow: 0 1px 1px rgb(0 0 0 / 5%);
	/*margin-right: 24px;
	margin-bottom: 24px; */
}
.RFlex > .boxBorder {
	margin-right: 0 !important;
}
.boxBorder > .titleBox {
	height: 48px;
	padding: 10px 0 0 10px;
	background: #fafafa;
	font-weight: bold;
}
.boxBorder > .contentBox {
	padding: 15px;
}
table {
	width: 100%;
	border: 1px solid #dfdfdf;
	border-collapse: collapse;
}
th {
	height: 35px;
	background-color: #fafafa;
	font-size: 0.8em;
	font-weight: bold;
}
td {
	height: 32px;
	font-size: 0.7em;
}
th,
td {
	border: 1px solid #dfdfdf;
	text-align: center;
}
.iconBox > div > div {
	display: flex;
	flex-direction: column;
	border: 1px solid #37474f;
	text-align: center;
}
.iconBox > div > div > img {
	width: 70px;
}
.iconBox > div > div > span {
	font-size: 13px;
	padding: 3px;
	color: #37474f;
}

#rootVM [process] > div > div {
	flex: 1;
	border-right: 1px solid #ddd;
	display: flex;
	flex-direction: column;
}
#rootVM [process] > div > div:last-child {
	border: none;
}
#rootVM [process] [left] > div:last-child {
	border: none;
}
#rootVM [process] img {
	width: 33px;
	margin-right: 8px;
}

#rootVM [process] > div {
	align-items: center;
}
#rootVM [process] > div > div > div {
	display: flex;
	align-items: center;
	justify-content: center;
}
#rootVM [process] > div > div > div:first-child {
	font-weight: bold;
}
#rootVM [process] > div > div > div:last-child {
	/* margin-top: 20px; */
	margin-top: 3px;
}
#rootVM [process] > div > div > div:last-child span {
	font-size: 1.6em;
	font-weight: bold;
	color: #034ea2;
	text-decoration: underline;

	margin-right: 5px;
}

#lineChart {
	/* width: 600px; */
	width: 100%;
	height: 300px;
}

/* 노트북 사이즈 */
@media only screen and (max-width: 1780px) {
	/* #rootVM [process] > div > div > div:last-child { margin-top:5px; }
  #rootVM [process] > div { max-height:130px; }
  #rootVM [bottom] [current] { height:200px; max-height:150px; min-height:150px; } */
}

.object-danger-content {
	height: 88%;
	overflow-y: scroll;
}
.object-danger {
	width: 100%;
	display: block;
	font-size: 13.5px !important;
}
.object-danger > .red {
	color: rgb(255, 58, 58);
}
.object-danger > .blue {
	color: rgb(89, 193, 245);
}
.object-danger > table {
	/* margin-bottom: 15px; */
	margin-bottom: 5px;
}
.object-danger > table > tr > td {
	height: 10px;
	background-color: rgb(240, 240, 240);
}
.object-danger > table > tr > .red {
	background-color: rgb(255, 58, 58);
}
.object-danger > table > tr > .blue {
	background-color: rgb(89, 193, 245);
}
.object-danger-row {
	display: flex;
	justify-content: space-between;
	margin-bottom: 5px;
}
.object-danger-row > div {
	overflow: hidden;
	white-space: nowrap;
	font-weight: bold;
	font-size: 1.25rem;
}
.object-danger-row > .name {
	width: 40%;
}
.object-danger-row > .value {
	width: 40%;
	text-align: right;
}
.object-danger-row > .value > .percent {
	font-weight: lighter;
	font-size: 0.8em;
	color: black;
}
.today-wwo-title {
	cursor: pointer;
}
[no-result] {
	width: 110px;
	margin: 60px;
}
.rt-dvsn {
	background: #d15661;
	color: #fff;
	font-size: 15px;
	width: fit-content;
	margin-left: 2px;
	padding: 2px 5px 0 5px;
	border-radius: 5px;
}
.rt-row {
	display: inline-flex;
}
.rt-row-tt {
	font-size: 16px;
	width: 90px;
}
.rt-row-ct {
	font-size: 16px;
	width: 230px;
}
[notice] > div {
	display: flex;
	width: 1080px;
	height: 30px;
	padding: 0px;
	font-size: 15px;
	margin-top: 10px;
	cursor: pointer;
}
[notice] > div > div:not(:first-child) {
	margin-top: 2px;
}
[notice] > div > div {
	margin: 0px 10px;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}
[notice] > div .nt-guide {
	background: rgb(92, 185, 92);
	color: rgb(255, 255, 255);
	font-size: 15px;
	width: 12%;
	padding: 2px 10px 0 10px;
	border-radius: 5px;
	text-align: center;
}

*:focus {
	outline: none;
}
.modal-content img {
	width: 100%;
	height: 100%;
	object-fit: contain;
}

.modal-content [photo] {
	cursor: pointer;
	border-radius: 4px;
	overflow: hidden;
}
.modal-content [photo] img {
	min-height: 120px;
	height: 120px;
}

.modal-content [left] [photo] {
	margin-top: 20px;
}
.modal-content [photo].active {
	border: 5px solid #1878f3;
	box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 5px;
}

@media (min-width: 500px) and (max-width: 1800px) {
	.modal-content {
		background-color: #fefefe;
		margin: 1% auto;
		padding: 20px;
		border: 1px solid #888;
		width: 80%;
	}
	.modal-content [left] {
		padding: 0 15px;
		height: 85vh !important;
	}
	#popupImg {
		width: 55vw !important;
		max-height: 55vh !important;
	}
}

@media (min-width: 1801px) {
	.modal-content {
		background-color: #fefefe;
		margin: 4% auto;
		padding: 20px;
		border: 1px solid #888;
		width: 1300px;
		height: 800px;
	}
	.modal-content [left] {
		padding: 0 15px;
	}
}
.modal {
	display: none; /* Hidden by default */
	position: fixed; /* Stay in place */
	z-index: 99; /* Sit on top */
	left: 0;
	top: 0;
	width: 100%; /* Full width */
	height: 100%; /* Full height */
	background-color: rgb(0, 0, 0); /*Fallback color */
	background-color: rgba(0, 0, 0, 0.4); /* //Black w/ opacity */
}

/* The Close Button */
.close {
	color: #aaa;
	float: right;
	font-size: 28px;
	font-weight: bold;
}
.close:hover,
.close:focus {
	color: black;
	text-decoration: none;
	cursor: pointer;
}
.border {
	border-radius: 3px;
	border: 1px solid #ddd;
	float: left;
}
.border-bottom {
	width: 90%;
	margin: auto;
	border-bottom: 1px solid #ddd !important;
}
.rhtBox {
	/* height: 135px; */
	min-height: 135px;
	height: auto;
}
.rhtBox > div:first-child {
	/* background: #f9f9f9; */
	background: #e0e0e0;
}
h3 {
	font-weight: bold !important;
	margin: 0 !important;
	padding: 10px 10px 10px 15px;
}
.mBox {
	/* height: 135px; */
	height: 170px;
	/* height: 100%; */
	border-radius: 3px;
	border: 1px solid #ddd;
	/* margin-bottom: 50px; */
	margin-bottom: 30px;
	margin-top: 30px;
}
.mBox > div > h4 {
	background: #e0e0e0;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
	-webkit-appearance: none;
}

.objects > div:first-child {
	font-size: 17px !important;
	font-weight: bold !important;
}
</style>
